import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import styles from './styles.module.css';

type Variant = 'error' | 'text' | 'strongNotation';
type Props = {
  children: ReactNode;
  variants?: Variant[];
};
const Caption: FC<Props> = ({ children, variants = [] }) => {
  const captionClassName = classNames(
    styles.caption,
    variants.map((v) => styles[v])
  );
  return <div className={captionClassName}>{children}</div>;
};
export default Caption;

export function CaptionsUnderForm({ children }: { children?: ReactNode }) {
  return <div className={styles.captionsUnderForm}>{children}</div>;
}
